import { useAuth0 } from '@auth0/auth0-react'
import { datadogRum } from '@datadog/browser-rum'
import { CssBaseline } from '@mui/material'
import moment from 'moment'
import 'moment/dist/locale/de'
import 'moment/dist/locale/fr'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BrowserRouter as Router } from 'react-router-dom'
import { ComstructRoutes } from 'routes/comstruct_routes'
import ComstructThemeProvider from 'themes/comstruct_theme.provider'
import './App.css'

const AUTH_AUDIENCE = process.env.VITE_AUTH_AUDIENCE ?? ''

/**
 * Main App component
 */
function App() {
  const {
    isAuthenticated,
    isLoading,
    getAccessTokenSilently,
    getAccessTokenWithPopup,
  } = useAuth0()
  const [token, setToken] = useState<string | undefined>(undefined)
  const { i18n } = useTranslation()
  moment.locale(i18n.language)
  //loadLocale()
  useEffect(() => {
    if (!isAuthenticated) return
    const fct = async () => {
      try {
        setToken(await getAccessTokenSilently({ audience: AUTH_AUDIENCE }))
      } catch (e) {
        console.log(e)
        setToken(await getAccessTokenWithPopup())
      }
    }
    fct()
    // Authenticated, so we can initialize Datadog RUM
    datadogRum.init({
      applicationId: process.env.VITE_DD_APPLICATION_ID ?? '',
      clientToken: process.env.VITE_DD_CLIENT_TOKEN ?? '',
      site: 'datadoghq.eu',
      service: 'comstruct-web',
      version: process.env.VITE_DD_APP_VERSION ?? '',
      env: window.location.hostname,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
    })
  }, [isAuthenticated, getAccessTokenSilently, getAccessTokenWithPopup])

  return (
    <Router>
      <ComstructThemeProvider>
        <CssBaseline enableColorScheme />
        <ComstructRoutes
          isLoading={isLoading}
          token={token}
          isAuthenticated={isAuthenticated}
        />
      </ComstructThemeProvider>
    </Router>
  )
}

export default App
